import { Component } from '@angular/core';
import { cloneDeep } from 'lodash';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AntennaModel } from 'src/app/models/antennaModel';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { SelectAntennaPatternService } from 'src/app/services/select-antenna-pattern.service';
import { UiBlockService } from 'src/app/services/ui-block.service';
import { AddAntennaModelComponent } from '../add-antenna-model/add-antenna-model.component';
import { PointsService } from 'src/app/services/points.service';
import { Feature } from 'ol';
import { Geometry } from 'ol/geom';
import { ModalConfirmationService } from 'src/app/services/modal-confirmation.service';

@Component({
  selector: 'app-select-antenna-pattern',
  templateUrl: './select-antenna-pattern.component.html',
  styleUrls: ['../../app.component.scss'],
  standalone: false
})
export class SelectAntennaPatternComponent {

  selectedRow: AntennaModel;

  constructor(public bsModalRef : BsModalRef,
    public popupService: BsModalService,
    public antennaPatternService: SelectAntennaPatternService,
    private uiBlock: UiBlockService,
    private modalService : ModalControlService,
    private pointsService: PointsService,
    private confirmationModalService : ModalConfirmationService)
    {
      this.antennaPatternService.getAllAntennaModels();
    }


  selectRow(row: AntennaModel) {
    if (row.selected){
      row.selected = false;
      this.selectedRow = null;
      return;
    }
    for (const rowIte of this.antennaPatternService.antennaModels){
      rowIte.selected = false;
    }
    row.selected = true;
    this.selectedRow = row;
  }

  downloadFile(model: AntennaModel) {
    this.antennaPatternService.downloadAntennaFile(model.modelName);
  }

  addAntennaModel(){
    const bsModalRef : BsModalRef = this.popupService.show(AddAntennaModelComponent);
    bsModalRef.content.editModeAntennaName = "";
    bsModalRef.content.antennaModel = new AntennaModel();
    bsModalRef.content.onClose
    .subscribe({
      next: (savedAntennaModel: AntennaModel) => {
        if (savedAntennaModel != null){
          this.antennaPatternService.antennaModels.push(cloneDeep(savedAntennaModel));
        }
      },
    })
  }


  editSelectedAntennaModel(){
    if (this.selectedRow == null){
      this.modalService.showMesssageModal("Antenna Model Selection", "Please select an Antenna Model to be edited.")
      return;
    }

    if (this.selectedRow.id == null){
      this.modalService.showMesssageModal("Antenna Model Selection", "You can not edit default Antenna Models.")
      return;
    }

    const bsModalRef : BsModalRef = this.popupService.show(AddAntennaModelComponent);
    bsModalRef.content.editModeAntennaName = this.selectedRow.modelName;
    bsModalRef.content.antennaModel = cloneDeep(this.selectedRow);
    bsModalRef.content.onClose
    .subscribe({
      next: (savedAntennaModel: AntennaModel) => {
        if (savedAntennaModel != null){
          let rowSelected: number = this.antennaPatternService.antennaModels.indexOf(this.selectedRow);
          this.antennaPatternService.antennaModels[rowSelected] = cloneDeep(savedAntennaModel);
          this.selectedRow = null;
        }
      },
    })

  }

  async deleteSelectedRow() {
    if (this.selectedRow == null){
      this.modalService.showMesssageModal("Antenna Model Selection", "Please select an Antenna Model to be removed.")
      return;
    }
    this.uiBlock.startBlock("Deleting Antenna Model...")
    try {
      let rowSelected: number = this.antennaPatternService.antennaModels.indexOf(this.selectedRow);
      if (rowSelected != -1){
        if (this.selectedRow.id == null){
          this.modalService.showMesssageModal("Antenna Model Selection", "You can not remove default Antenna Models.")
          return;
        }
        const navaidsOnMap: Feature<Geometry>[] = this.pointsService.getAllNavaidsFeaturesFromLayers();
        const navaidsWithSelectedAntenna = navaidsOnMap.filter(n => n.get("antennaModelName") == this.selectedRow.modelName);
        if (navaidsWithSelectedAntenna.length > 0){
          this.confirmationModalService.showMesssageConfirmationModal("Antenna Model Selection",
          `The following NavAids use this Antenna Model: ${navaidsWithSelectedAntenna.map(n => n.get("navaidid")).join(', ')}.
          Do you wish to proceed?`, "Yes", "No",
          () => this.deleteAntennaModel(this.selectedRow, rowSelected));
          return;
        }
        this.confirmationModalService.showMesssageConfirmationModal("Antenna Model Selection",
        'This will delete the selected Antenna Model. Do you wish to proceed?', "Yes", "No",
        () => this.deleteAntennaModel(this.selectedRow, rowSelected));
      }
    } catch (e){
      this.modalService.showMesssageModal("Antenna Model Selection", "Error deleting selected Antenna Model.");
    } finally {
      this.uiBlock.stopBlock();
    }
  }

  private async deleteAntennaModel(selectedRow: AntennaModel, rowIndex: number){
    const deleteSucessfull: boolean = await this.antennaPatternService.deleteAntennaModel(this.selectedRow.id);
      if (!deleteSucessfull){
        throw new Error("Error deleting Antenna Model")
      }
      this.antennaPatternService.antennaModels.splice(rowIndex, 1);
      this.selectedRow = null;
  }



}
